<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>
          <v-btn block color="primary" @click="showForm=true">Bestellung/Änderung starten</v-btn>
        </v-flex>
        <v-flex xs4 ml-2 pa-0>
          <v-text-field
            append-icon="mdi-magnify"
            hide-details
            label="Suchen"
            single-line
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :sort-by="['startTime']"
        :sort-desc="[true]"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.neubestellung="{ item }">{{ item.neubestellung ? 'Neu' :'Änderung'}}</template>
        <template
          v-slot:item.startTime="{ item }"
        >{{ new Date(item.startTime).toLocaleDateString(undefined,{day:'2-digit', month:'2-digit',year:'numeric', hour: '2-digit', minute: '2-digit' })}}</template>
        <template v-slot:item.action="{ item }">
          <v-tooltip v-if="item.partnerTask" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
              class="mr-2"
                @click="createDocument(item)"
                v-if="item.partnerTask"
                v-on="on"
              >mdi-file-document</v-icon>
            </template>
            <span>Dokumente für Bestellung erstellen</span>
          </v-tooltip>
          <v-tooltip v-if="item.partnerTask" bottom>
            <template v-slot:activator="{ on }">
              <v-icon class="mr-2" @click="continueTask(item)" v-on="on">mdi-pencil</v-icon>
            </template>
            <span>Bestellung weiterführen</span>
          </v-tooltip>
          <v-tooltip v-if="item.partnerTask" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                @click="stopTask(item)"
                v-if="item.partnerTask && item.taskDefinitionKey!=='Task_01rcvi0' && item.taskDefinitionKey!=='Task_1xomhzu'"
                v-on="on"
              >mdi-delete</v-icon>
            </template>
            <span>Bestellung Löschen</span>
          </v-tooltip>
          <div v-else-if="!item.partnerTask">Zur Bearbeitung bei T2med</div>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Bestellung wirklich löschen?</v-card-title>
        <v-card-text>Das Löschen der Bestellung kann nicht rückgängig gemacht werden.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">Nein</v-btn>
          <v-btn color="blue darken-1" text @click="stopOrder">Bestellung löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showForm" max-width="600">
      <v-card>
        <v-card-title class="headline">Bestellung/Änderung starten</v-card-title>
        <v-card-text>
          <p class="red--text font-weight-bold">
          Für jede Praxis darf nur eine Neubestellung angelegt werden. </p>
          <p>
Bei jeder weiteren Anpassung handelt es sich um eine Lizenzänderung.
          <p><span class="red--text font-weight-bold">ACHTUNG</span>: Wird eine Lizenz für ein und dieselbe Praxis doppelt angelegt, kann es zu schwerwiegenden <span class="red--text font-weight-bold">Komplikationen</span> während des Konvertierungsprozesses kommen, sowie eine deutlich <span class="red--text font-weight-bold">längere Bearbeitungszeit</span> des Lizenz-Erstellungsprozesses bei T2med nach sich ziehen!</p>
          <v-checkbox
            v-model="newOrder"
            label="Neubestellung - mir liegt keine Lizenzdatei vor"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="startOrder">Bestellung/Änderung starten</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      items: state => state.activeProcesses,
      lizenzaenderung: state => state.lizenzaenderung
    })
  },
  created: function() {
    this.$store.commit("startLoading");
    this.$socket.sendObj({
      eventID:
        "de.t2med.lizenzomat.eventapi.usecase.activiti.ActiveProcessesRequestEvent"
    });
  },
  mounted: function() {
    this.$store.commit("clearCurrent");
  },
  methods: {
    startOrder() {
      this.$store.commit("startLoading");
      if (this.newOrder) {
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.activiti.StarteNeubestellungRequestEvent"
        });
      } else {
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.activiti.StartModificationRequestEvent"
        });
      }
    },
    createDocument(task){
      this.$router.push(
        `/Dokument/${task.processInstanceID}/${task.taskId}`
      )
    },
    continueTask(task) {
      this.$router.push(
        `/${task.taskDefinitionKey}/${task.processInstanceID}/${task.taskId}`
      );
    },
    stopTask(task) {
      this.deleteDialog = true;
      this.processId = task.processInstanceID;
      this.taskId = task.taskId;
    },
    stopOrder() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.activiti.StopProcessRequestEvent",
        processId: this.processId,
        taskId: this.taskId
      });
      this.deleteDialog = false;
      this.processId = null;
    }
  },
  data() {
    return {
      search: "",
      showForm: false,
      newOrder: false,
      deleteDialog: null,
      headers: [
        { text: "Typ", value: "neubestellung" },
        { text: "Datum", value: "startTime" },
        { text: "Praxisname", value: "name" },
        { text: "T2med-Lizenz-ID", value: "t2medId" },
        { text: "Nutzer", value: "user" },
        { text: "Nächste Aufgabe", value: "nextTaskName" },
        { text: "Beschreibung", value: "nextTaskDescription" },
        { text: "Aktionen", value: "action", sortable: false }
      ]
    };
  }
};
</script>
